import { PolarQuestion } from '../components';
import {
  AffordabilityFormDataType,
  AffordabilityRequest,
  LoanType,
  PropertyType,
} from '../types/affordability';

export function mapFormDataToAffordabilityRequest(
  data: AffordabilityFormDataType,
): AffordabilityRequest {
  return {
    loanData: {
      propertyType: data.propertyType,
      municipality: data.municipality,
      downpayment: parseFloat(data.downpayment),
      monthlyPayment:
        data.propertyType === PropertyType.Apartment
          ? parseFloat(data.monthlyPayment)
          : 0,
      monthlyExpense:
        data.propertyType === PropertyType.Villa ||
        data.propertyType === PropertyType.HolidayHouse
          ? parseFloat(data.monthlyPayment)
          : 0,
    },
    applicant: { monthlyIncome: parseFloat(data.primaryApplicantIncome) },
    ...(data.secondaryApplicantExist === PolarQuestion.Yes
      ? {
          coapplicant: {
            monthlyIncome: parseFloat(data.secondaryApplicantIncome),
          },
        }
      : {}),
    numberOfChildren: data.children,
    numberOfCars: data.cars,
    properties: data.properties.map((property) => ({
      type: property.propertyType,
      remainingDebt: parseFloat(property.remainingDebt),
      monthlyPayment: parseFloat(property.monthlyPayment),
    })),
    loans: data.debts
      .filter((debt) => debt.loanType !== LoanType.CreditCard)
      .map((debt) => ({
        type: debt.loanType,
        remainingDebt: parseFloat(debt.remainingDebt),
        monthlyPayment: parseFloat(debt.monthlyPayment),
      })),
    creditCards: data.debts
      .filter((debt) => debt.loanType === LoanType.CreditCard)
      .map((debt) => ({
        limit: parseFloat(debt.creditLimit),
      })),
  };
}
